import { SELECT } from '@/Reporting/config/constants';
import axios from 'axios';

const checkGraphData = (payload, graphData) => {
  const isLeftResultUndefined = graphData.find(e => e.key === payload.selectedLeftDropdown);

  if (!isLeftResultUndefined && payload.selectedRightDropdown !== SELECT) {
    const hasComparison = graphData.find(c => c.comparison);
    if (hasComparison) {
      const createComparisonBuckets = graphData[0].search.buckets[0].dates.buckets.reduce(
        (acc, data) => {
          const buckets = {
            doc_count: 0,
            key_as_string: data.key_as_string,
          };
          return [...acc, buckets];
        },
        [],
      );

      const createSearchBuckets = graphData[0].search.buckets[0].dates.buckets.reduce(
        (acc, data) => {
          const buckets = {
            doc_count: 0,
            key_as_string: data.key_as_string,
          };
          return [...acc, buckets];
        },
        [],
      );

      const fillEmptyData = {
        key: payload.selectedLeftDropdown,
        search: {
          buckets: [
            {
              dates: {
                buckets: createSearchBuckets,
              },
            },
          ],
        },
        comparison: {
          buckets: [
            {
              dates: {
                buckets: createComparisonBuckets,
              },
            },
          ],
        },
      };
      graphData.push(fillEmptyData);
    } else {
      const createSearchBuckets = graphData[0].search.buckets[0].dates.buckets.reduce(
        (acc, data) => {
          const buckets = {
            doc_count: 0,
            key_as_string: data.key_as_string,
          };
          return [...acc, buckets];
        },
        [],
      );

      const fillEmptyData = {
        key: payload.selectedLeftDropdown,
        search: {
          buckets: [
            {
              dates: {
                buckets: createSearchBuckets,
              },
            },
          ],
        },
      };
      graphData.push(fillEmptyData);
    }
  }

  const isRightResultUndefined = graphData.find(e => e.key === payload.selectedRightDropdown);

  if (!isRightResultUndefined && payload.selectedRightDropdown !== SELECT) {
    const hasComparison = graphData.find(c => c.comparison);
    if (hasComparison) {
      const createComparisonBuckets = graphData[0].search.buckets[0].dates.buckets.reduce(
        (acc, data) => {
          const buckets = {
            doc_count: 0,
            key_as_string: data.key_as_string,
          };
          return [...acc, buckets];
        },
        [],
      );

      const createSearchBuckets = graphData[0].search.buckets[0].dates.buckets.reduce(
        (acc, data) => {
          const buckets = {
            doc_count: 0,
            key_as_string: data.key_as_string,
          };
          return [...acc, buckets];
        },
        [],
      );

      const fillEmptyData = {
        key: payload.selectedRightDropdown,
        search: {
          buckets: [
            {
              dates: {
                buckets: createSearchBuckets,
              },
            },
          ],
        },
        comparison: {
          buckets: [
            {
              dates: {
                buckets: createComparisonBuckets,
              },
            },
          ],
        },
      };
      graphData.push(fillEmptyData);
    } else {
      const createBuckets = graphData[0].search.buckets[0].dates.buckets.reduce((acc, data) => {
        const buckets = {
          doc_count: 0,
          key_as_string: data.key_as_string,
        };
        return [...acc, buckets];
      }, []);

      const fillEmptyData = {
        key: payload.selectedRightDropdown,
        search: {
          buckets: [
            {
              dates: {
                buckets: createBuckets,
              },
            },
          ],
        },
      };
      graphData.push(fillEmptyData);
    }
  }
  const setValues = formatGraphValues(payload, graphData);
  return setValues;
};

const formatGraphValues = (payload, graphData) => {
  const searchValues = graphData.reduce((acc, data) => {
    const [search] = data.search.buckets;
    let finalValue = {
      search: {
        eventType: data.key,
        data: search.dates.buckets.map(dc => dc.doc_count),
        timeString: search.dates.buckets.map(k => k.key_as_string),
        dateRange: [search.from_as_string, search.to_as_string],
      },
    };

    if (data.comparison) {
      const [comparison] = data.comparison.buckets;
      finalValue = {
        ...finalValue,
        comparison: {
          eventType: data.key,
          data: comparison.dates.buckets.map(dc => dc.doc_count),
          timeString: comparison.dates.buckets.map(k => k.key_as_string),
          dateRange: [comparison.from_as_string, comparison.to_as_string],
        },
      };
    }
    return [...acc, finalValue];
  }, []);

  const setValues = setGraphLinesInitialPositions(payload, searchValues);
  return setValues;
};

const setGraphLinesInitialPositions = (payload, searchValues) => {
  if (
    payload.selectedRightDropdown !== SELECT &&
    searchValues[0].search.data.length !== searchValues[1].search.data.length
  ) {
    const arrOfLengths = searchValues.reduce((acc, val) => {
      return [...acc, val.search.data.length];
    }, []);

    const longestDataset = searchValues.find(
      d => d.search.data.length === Math.max(...arrOfLengths),
    );
    const smallestDataset = searchValues.find(
      d => d.search.data.length === Math.min(...arrOfLengths),
    );
    const matchDates = longestDataset.search.timeString.find(
      d => d === smallestDataset.search.timeString[0],
    );
    const index = longestDataset.search.timeString.indexOf(matchDates);
    const arr = Array(index).fill(null);

    smallestDataset.search.data = [...arr, ...smallestDataset.search.data];
    smallestDataset.search.timeString = [...arr, ...smallestDataset.search.timeString];

    searchValues = [longestDataset, smallestDataset];
  }

  return searchValues;
};

export default {
  namespaced: true,
  state: {
    graphError: null,
    isGraphLoading: false,
    graphData: [],
    responseIfNoData: true,
  },
  mutations: {
    setGraphError(state, error) {
      state.graphError = error;
    },
    setGraphLoading(state, isLoading) {
      state.isGraphLoading = isLoading;
    },
    setResponseIfNoData(state, value) {
      state.responseIfNoData = value;
    },
    setGraphData(state, finalGraphData) {
      state.graphData = finalGraphData;
    },
  },
  actions: {
    async getInfoForReportingGraph(
      { commit },
      {
        dateRange,
        comparison,
        selectedTimeInterval,
        selectedLeftDropdown,
        selectedRightDropdown,
        selectedFilter,
      },
    ) {
      commit('setGraphLoading', true);
      let eventTypes;
      if (selectedRightDropdown === SELECT) {
        eventTypes = [selectedLeftDropdown];
      } else {
        eventTypes = [selectedLeftDropdown, selectedRightDropdown];
      }

      let request = {
        date_range: dateRange,
        interval: selectedTimeInterval,
        event_types: eventTypes,
        compare: comparison,
        target: '',
        target_agent_type: '',
        target_ids: [],
      };

      if (selectedFilter && selectedFilter.length) {
        request.target = selectedFilter[0].target;
        request.target_ids = selectedFilter.map(i => i.id);

        if (selectedFilter[0].target === 'agent') {
          request.target_agent_type = selectedFilter[0].target_type;
        }
      }

      try {
        const res = await axios.post(
          `${process.env.VUE_APP_EVENTS_API_BASE_URL}/reporting/graph-data`,
          request,
        );
        const payload = {
          dateRange,
          selectedTimeInterval,
          selectedLeftDropdown,
          selectedRightDropdown,
        };
        const graphData = [...res.data.data];

        if (!graphData.length) {
          commit('setResponseIfNoData', true);
        } else {
          const finalGraphData = checkGraphData(payload, res.data.data);
          commit('setGraphData', finalGraphData);
          commit('setResponseIfNoData', false);
        }
      } catch (error) {
        commit('setGraphError', error);
      } finally {
        commit('setGraphLoading', false);
      }
    },
  },
};
